<template>

  <v-app height="100%">

  <span class="bg"></span> 
  <v-toolbar
      :extended=false
      :prominent=false
      :dense=false
      :collapse=false
      :flat=true
      width="100%"
     >
      <div style="width:100%">
        <v-layout justify-space-between align-center>
      <div><img  src="https://www.vacationinbox.com/img/vacation_inbox_logo_on_transparent-01.png" height="50px"/></div>
      <div v-if="width > 600"><span style="font-weight: bold;">Frequently Asked Questions</span></div>
      <div v-if="width <= 600"><span style="font-weight: bold;">FAQ</span></div>
        </v-layout>
      </div>
   </v-toolbar>   
   <v-container>

    <v-layout 
      align-start
      justify-center
      fill-height
     >

       <v-flex >
        <v-card flat >        

          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="faq in faqs"
              :key="faq.id"
            >
              <div slot="header" style="background-color:#3953a3; margin-left: auto; margin-right: auto; text-align: center;">
                 <span style="color:white">{{faq.title}}</span>
              </div>
             <div style="text-align: center;width: 90%">



              <v-expansion-panel>
                <v-expansion-panel-content
                  v-for="q in faq.questions"
                 :key="q.id"
                >
                  <div slot="header">
                    <span style="color:#3953a3;">{{q.question}}</span>
                  </div>

                  <v-card
                    class="pl-4"                  
                  >
                    <span class="subtitle-1">{{q.answer}}</span>
                  </v-card>


                  
               </v-expansion-panel-content>
              </v-expansion-panel>
             
              <div
                v-for="item in faq.icons"
                :key="item.id"
                 class="pl-5"
              >
                <v-layout justify-start>
                  <div>
                    <v-icon color="#3953a3"> {{item.icon}}</v-icon>
                  </div>
                  <div style="padding-left:4px"></div>
                  <div>
                    <span class="subtitle-1">{{item.text}}</span>
                  </div>
                </v-layout>
              </div>

                
             </div>
           </v-expansion-panel-content>
         </v-expansion-panel>
       </v-card>
      </v-flex> 
    </v-layout>


  </v-container>


  </v-app>
</template>
<script>

export default {
  name: 'FAQs',
  data: function() {
    return {
      faqs: [],
      width: 600,
    }
  },
  mounted() {
    this.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.faqs = this.getFAQ();
  },
  methods: {
    getFAQ() {
       var self = this;
       fetch('faq.json', {
        method: "GET",
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(resp) {
          self.faqs=resp;
          return resp;
        })
        .catch(function(error) {
          self.error = error;
          alert("Unable to retieve FAQ");
        })     
    }
  }
}
</script>
<style lang="scss">
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: url( 'https://www.vacationinbox.com/img/background2.png') no-repeat center center;
    background-size: cover;
    transform: scale(1.1);
  }

</style>

